const autocompleteModalEquipService = {
  serviceType: 'Tipo do Serviço',
  frequency: 'Periodicidade',
  mandatory: 'Serviço é obrigatório?',
  expirationOnLastDayOfMonth: 'Vencimento no final do mês',
  allowMassService: 'Permitir criar serviços em massa',
  mandatoryActions: 'Ações são obrigatórias para perguntas com resposta "Não Atende"?',
  enableSignature: 'Habilitar Assinatura',
  mandatorySignature: 'Assinatura obrigatória',
};

export default autocompleteModalEquipService;
